import React from "react";
import { Route } from "react-router-dom";
import Print from "../../../containers/modules/log/print";

export default function PrintRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="print"
      index 
      element={
        <Print/>
      }
    />
  );
}
